import { Icon, InlineStack, List, ListItem, Text } from '@customerio/pluma-components/react';

type CheckListProps = {
  items: readonly string[];
};

export function CheckList({ items }: CheckListProps) {
  return (
    <List styleType="none" gap="100">
      {items.map((item) => (
        <ListItem key={item}>
          <InlineStack gap="150" alignBlock="center">
            <Icon name="check" size="sm" color="primary" flexShrink="0" />
            <Text>{item}</Text>
          </InlineStack>
        </ListItem>
      ))}
    </List>
  );
}
